/* import __COLOCATED_TEMPLATE__ from './browser-error.hbs'; */
import Component from '@ember/component';
import BrowserDetector from '../utils/browser-detector';
import { service } from '@ember/service';

export default class BrowserError extends Component {
    tagName = '';

    @service urlData;

    warning = null;

    init() {
        super.init();
        this.set('warning', BrowserDetector.badBrowserWarning('SAR Driver'));
    }
}
